import {baseProdConfig} from '../base/prod.config';
import {cnetStagingConfig} from './staging.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cnetProdConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseProdConfig, cnetStagingConfig, {
  environmentName: "Cnet Production Environment",
  hubApi: 'https://cms.cnet.com',
  ionicEnvName: 'prod',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cnet/prod.config.ts